import React, { useState } from "react";
import PropTypes from "prop-types";
import {
    StyledExapansionPanel,
    StyledPanelTitle,
    StyledContentExapnded,
} from "./styled";
import Divider from "../Divider";
import IconWrap from "../IconWrap";
import Icon from "../Icon";

const ExpansionPanel = ({ title, children, isExpanded, unexpandable, noDivider }) => {
    const [expanded, setExpanded] = useState(isExpanded);
    const handleClick = () => !unexpandable && setExpanded(prevExpanded => !prevExpanded);
    return (
        <StyledExapansionPanel unexpandable={unexpandable} expanded={expanded}>
            <StyledPanelTitle onClick={handleClick}>
                <span>{title}</span>
                {!unexpandable && (
                    <IconWrap rotate={expanded ? 360 : 180} align="right">
                        <Icon name="arrow" />
                    </IconWrap>
                )}
            </StyledPanelTitle>
            <StyledContentExapnded>{children}</StyledContentExapnded>
            {!noDivider && <Divider />}
        </StyledExapansionPanel>
    );
};

ExpansionPanel.propTypes = {
    title: PropTypes.string,
    children: PropTypes.node,
    isExpanded: PropTypes.bool,
    unexpandable: PropTypes.bool,
    noDivider: PropTypes.bool,
};

ExpansionPanel.defaultProps = {
    title: "Expansion panel",
    children: "Expandable content",
    isExpanded: false,
    unexpandable: false,
    noDivider: false,
};

export default React.memo(ExpansionPanel);
